export const typografLite = (text) => {
  if (typeof text !== "string") return text;
  return text
    .replace(/(\d+)\s?(МБ|ГБ|КБ|ТБ|fps)\b/gi, "$1\u00A0$2")

    .replace(
      /(^|[\s\u00A0])([вксоауи]|без|под|над|при|для|через|между|по|из|от|до|на|за|об|обо|про|со|ко|)\s+(?=[а-яёa-z])/gi,
      "$1$2\u00A0"
    );
};

export const typografLiteHTML = (html) => {
  if (typeof html !== "string") return html;
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const walker = doc.createTreeWalker(doc.body, NodeFilter.SHOW_TEXT);
  while (walker.nextNode()) {
    const node = walker.currentNode;
    node.nodeValue = typografLite(node.nodeValue);
  }
  return doc.body.innerHTML.replace(/&nbsp;/g, "\u00A0");
};
